import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  constructor() { }

  //With daylight fix
  convertUtcToUserTimezoneWithDayLight(dateString, firstSession, useCurrentTimezone, timezone) {

    if(useCurrentTimezone){
      timezone = moment.tz.guess();
    } 
    var convertedDate = moment.utc(dateString).tz(timezone).format('YYYY-MM-DD');
    var convertedTime = moment.utc(firstSession.split(' ')[0] + ' ' + dateString.split(' ')[1]).tz(timezone).format('HH:mm');
    return new Date(convertedDate + " " + convertedTime);
  }

   convertUtcToUserTimezone(dateString, useCurrentTimezone, timezone) {

    if(useCurrentTimezone){
      timezone = moment.tz.guess();
    } 
   return new Date(moment.utc(dateString).tz(timezone).format('YYYY-MM-DD HH:mm'));
  }

 convertScheduleToUserTimezone(sessions, schedule, useCurrentTimezone, venueTimeZone){
   let weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

    sessions.map((session, i)=>{
        session['startdate'] = this.convertUtcToUserTimezone(session['startdate'], useCurrentTimezone, venueTimeZone);
        session['enddate'] = this.convertUtcToUserTimezone(session['enddate'], useCurrentTimezone, venueTimeZone);
    });
    schedule.map((scheduleSession, i)=>{
      let startTime = this.convertUtcToUserTimezone(this.getDateByDayOfWeek(weekDays.indexOf(scheduleSession['day']), scheduleSession['starttime'], sessions[0]['startdate']), useCurrentTimezone, venueTimeZone);
      scheduleSession['starttime'] = startTime.toTimeString().split(' ')[0];
      let endTime = this.convertUtcToUserTimezone(this.getDateByDayOfWeek(weekDays.indexOf( scheduleSession['day']), scheduleSession['endtime'], sessions[0]['startdate']), useCurrentTimezone, venueTimeZone);
      scheduleSession['endtime'] = endTime.toTimeString().split(' ')[0];
      scheduleSession['day'] = weekDays[startTime.getDay()];
  });
   return {
       sessions: sessions,
       schedule: schedule
   }
}

getDateByDayOfWeek(dayOfWeek, time, startDate) {
  const date = new Date(startDate);
  date.setUTCHours(0);
  const currentDayOfWeek = date.getUTCDay();
  const diff = (dayOfWeek + 7 - currentDayOfWeek) % 7;
  date.setUTCDate(date.getUTCDate() + diff);
  
  const [hours, minutes, seconds] = time.split(':');
  date.setUTCHours(hours, minutes, seconds);
  
  return date.toISOString().replace('T', ' ').substring(0, 19);
}

 getTimezoneCode(timezone) {
    return moment.tz(timezone).zoneAbbr();
 }

 getUserTimezone() {
    return moment.tz(moment.tz.guess()).zoneAbbr();
 }

}
